/**
 *   Created by Arif Topcu in 2018
 */

import {connect} from 'react-redux';
import LookThruSwitch from './LookThruSwitch';
import {selectSelectedIsLookthru} from "state/selections/selectors";
import SelectionState from "state/selections/SelectionState";
import {setSelectedIsLookthru} from "state/selections/actions";

const mapStateToProps = state => ({
  checked: selectSelectedIsLookthru(SelectionState.UNCOMMITTED)(state),
});
const mapDispatchToProps = dispatch => ({
  onChange: (isLookthru) => dispatch(setSelectedIsLookthru(isLookthru)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LookThruSwitch);
